'use strict';

import {
    addCompanyTooltips, addExpandableColumnListener, addFormControlSelect2, addTopSearchColumn,
    dtTooltipName
} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export let fnSalaryStatusTable = function () {

    let tableName = '#datatable-salary-status';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    let salaryCompanyGrouping = $('#salary_company_grouping');
    salaryCompanyGrouping.select2({width: '271px', height: '75%'}).addClass('form-control');
    addFormControlSelect2();

    salaryCompanyGrouping.off('select2:select').on('select2:select', function (e) {
        let reportingPeriod = $('#reporting-period').val();
        let companyGroupingVal = salaryCompanyGrouping.val();

        $(tableName).DataTable().ajax.url('/salary/status/table/' + reportingPeriod + '/' + companyGroupingVal).load();
    });

    let reportingPeriod = $('#reporting-period').val();
    let companyGroupingVal = salaryCompanyGrouping.val() !== undefined ? salaryCompanyGrouping.val() : 'my_clients';

    let columns = [
        {data: 'id'},
        dtTooltipName(100, 1639),
        {data: 'salary_deadline'},
        {data: 'payroll_reported_column'},//html
        {data: 'payroll_reported'},//search field
        {data: 'pay_slips_for_approval_column'},//html
        {data: 'pay_slips_for_approval'},//search field
        {data: 'payslips_approved_column'},//html
        {data: 'payslips_approved'},//search field
        {data: 'payslips_sent_column'},//search field
        {data: 'payslips_sent'},//search field
        {data: 'payroll_done_column'},//html
        {data: 'payroll_done'},//search field
    ];

    /*Rules for filling the columns*/
    let columnDefs = [
        {visible: false, targets: 0},
        {visible: true, targets: 1, width: "35%"},
        {className: "text-center", visible: true, targets: 2},
        {className: "text-center", visible: true, targets: 3, orderData: 4},//html
        {className: "text-center", visible: false, targets: 4},//search field
        {className: "text-center", visible: true, targets: 5, orderData: 6},//html
        {className: "text-center", visible: false, targets: 6},//search field
        {className: "text-center", visible: true, targets: 7, orderData: 8},//html
        {className: "text-center", visible: false, targets: 8},//search field
        {className: "text-center", visible: true, targets: 9, orderData: 10},//html
        {className: "text-center", visible: false, targets: 10},//search field
        {className: "text-center", visible: true, targets: 11},//search field
        {className: "text-center", visible: false, targets: 12},//search field
    ];


    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');


    let table = $(tableName).DataTable({

        language: allLangFiles.datatables,

        rowId: 'id',
        ajax: {
            url: '/salary/status/table/' + reportingPeriod + '/' + companyGroupingVal,
            dataSrc: function (json) {

                return json.data;
            },
        },
        columns: columns,
        columnDefs: columnDefs,
        order: [[1, "asc"]],
        scrollX: true,
        orderCellsTop: true,
        lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
        initComplete: function (settings, json) {

            /*table.draw();*/
        },
        drawCallback: addCompanyTooltips,
    });

    addExpandableColumnListener(tableName, table);
    addTopSearchColumn(tableName, table);

    //redesignDataTablesHeader(tableName, false);
};